// Check if the number starts with 3 letters, either upper or lower case
export const isPolicyNumberFormat = (prnNumber) =>
  prnNumber.match(/^[a-zA-Z]{3}/) !== null;

export const isPolicyNumber = (prnNumber, policyNumber, typeOfPrn) =>
  typeOfPrn === 'Policy' && prnNumber === policyNumber;
